import React, { useEffect, useState } from 'react'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { HiOutlineX } from 'react-icons/hi'

const DropdownMultiSelect = ({ options, setFieldValue, fieldValue, selectedCapacity }) => {
    const filteredItems = options.filter((item) => selectedCapacity?.includes(item.uuid))
    const [selectedItems, setSelectedItems] = useState(filteredItems)
    const [uuid, setuuid] = useState(selectedItems.map((item) => item.uuid))

    useEffect(() => {
        setFieldValue(fieldValue, uuid)
    }, [uuid])  // eslint-disable-line react-hooks/exhaustive-deps

    const handleItemClick = (item) => {
        if (selectedItems.some((selected) => selected.uuid === item.uuid)) {
            setSelectedItems(selectedItems.filter((selected) => selected.uuid !== item.uuid))
        } else {
            setSelectedItems([...selectedItems, item])
        }
        setFieldValue(fieldValue, [...uuid, item.uuid])
    }


    const removeItem = (itemToRemove) => {
        const filteritem = selectedItems.filter((item) => item.uuid !== itemToRemove.uuid)
        setSelectedItems(filteritem)
        setuuid(filteritem.map((item) => item.uuid))
        setFieldValue(fieldValue, uuid)
    }
    if (!options) return

    return (
        <>
            <UncontrolledDropdown className="w-100" data-testid="dropDown">
                <DropdownToggle
                    style={{
                        border: '1px solid var(--grey-100, #e7e9ec)',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        fontSize: '16px',
                        height: '40px',
                        width: '100%',
                        background: 'white',
                        color: '#3d414c',
                        textAlign: 'left',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <span data-testid="selected" style={{ color: '#9DA3B0' }}>
                        {' '}
                        {selectedItems.length > 0
                            ? `${selectedItems.length} capacity zones selected`
                            : 'Select capacity zones...'}
                    </span>
                    <FontAwesomeIcon color="black" size="xs" icon={faChevronDown} />
                </DropdownToggle>
                <DropdownMenu
                    data-testid="testmenu"
                    className="col-12 scrolable"
                    style={{ overflow: 'auto', zIndex: 1000, maxHeight: '150px' }}
                >
                    {options?.map((item) => (
                        <DropdownItem
                            key={item.uuid}
                            value={item.uuid}
                            onClick={() => {
                                handleItemClick(item)
                            }}
                            active={selectedItems.some((option) => option.uuid === item.uuid)}
                        >
                            {item.title}
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </UncontrolledDropdown>

            <div className="mt-3">
                {selectedItems.length > 0 && (
                    <>
                        <div className="d-flex flex-wrap mt-2">
                            {selectedItems.map((item) => (
                                <span
                                    key={item.uuid}
                                    className=" rounded d-flex align-items-center text-meili px-2"
                                    style={{
                                        backgroundColor: '#F9EFFE',
                                        marginRight: '8px',
                                    }}
                                >
                                    {item.title}
                                    <HiOutlineX
                                        style={{
                                            cursor: 'pointer',
                                            color: '#D99EF7',
                                            marginLeft: '8px',
                                        }}
                                        onClick={() => removeItem(item)}
                                    />
                                </span>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </>
    )
}

export default DropdownMultiSelect
